import React from "react";
import CardLoading from "../../components/Jobs/CardLoading";
import { Box } from "@material-ui/core";

function SimilarJobLoading() {
  return (
    <Box className="similar-jobs">
      {[1, 2, 3].map((key) => (
        <CardLoading key={key} />
      ))}
    </Box>
  );
}

export default SimilarJobLoading;
